export enum ETipoRelatorioFluxoCaixa {
    Geral = 1,
    PorTipoDocumento = 2,
}
